<ng-container *ngIf="bankTransactionsService.transactionDetailsObservable$ | async as tx">
  <app-portal-detail-drawer
    variant="task"
    drawerTitle="Transaction Details"
    [resetScrollKey]="tx.transactionId"
    (backClick)="bankTransactionsService.closeDrawer()"
    (closeClick)="bankTransactionsService.closeDrawer()">
    <div class="bank-transaction-detail-drawer">
      <div class="bank-transaction-detail-header">
        <div class="title-section">
          <div class="title-row">
            <div class="title">{{ transactionTitle(tx) }}</div>
            <div class="transaction-actions">
              <button class="pill-action" type="button" (click)="attachmentPopup(false, false)">
                <mat-icon>attach_file</mat-icon>
                <span>Attach</span>
              </button>
            </div>
          </div>
          <div class="breadcrumb-row">
            <span>Transactions</span>
            <span>/</span>
            <span>{{ transactionTypeLabel(tx) }}</span>
            <span>/</span>
            <strong>{{ tx.transactionId || 'Details' }}</strong>
          </div>
        </div>
      </div>

      <app-portal-detail-section
        title="Basic details"
        [open]="isSectionOpen('basic')"
        (toggle)="toggleSection('basic')">
        <div class="transaction-meta-list">
          <div class="transaction-meta-line">
            <span>Bank Account</span>
            <strong>{{ tx.bankName || '-' }} / {{ tx.iban || '-' }}</strong>
          </div>
          <div class="transaction-meta-line">
            <span>Date</span>
            <strong>
              <mat-icon>event</mat-icon>
              {{ tx.executionDate ? commonService.formateDate(tx.executionDate) : '-' }}
            </strong>
          </div>
          <div class="transaction-meta-line">
            <span>Transaction Code</span>
            <strong>{{ tx.bankTransactionCode || '-' }}</strong>
          </div>
          <div class="transaction-meta-line">
            <span>Transaction Type</span>
            <strong class="transaction-type-chip" [ngClass]="transactionTypeClass(tx)">
              <span></span>{{ transactionTypeLabel(tx) }}
            </strong>
          </div>
          <div class="transaction-meta-line">
            <span>Currency</span>
            <strong>{{ tx.currency || '-' }}</strong>
          </div>
          <div class="transaction-meta-line">
            <span>Amount</span>
            <strong [ngClass]="tx.amount < 0 ? 'negative-amt' : 'positive-amt'">
              {{ ((tx.amount || 0) | number : '1.2' | convertWithDecimal:selectedVehicle:false:false:'') + ' €' }}
            </strong>
          </div>
        </div>
      </app-portal-detail-section>

      <app-portal-detail-section
        title="Payment information"
        [open]="isSectionOpen('payment')"
        (toggle)="toggleSection('payment')">
        <div class="transaction-copy-list">
          <div class="transaction-copy-item">
            <span>Purpose</span>
            <strong>{{ tx.description || '-' }}</strong>
          </div>
          <div class="transaction-copy-item">
            <span>Remittance information</span>
            <strong>{{ tx.remittanceInformation || '-' }}</strong>
          </div>
          <div class="transaction-copy-item">
            <span>Additional Info</span>
            <strong>{{ tx.additionalInformation || '-' }}</strong>
          </div>
        </div>
      </app-portal-detail-section>

      <app-portal-detail-section
        title="Counterparty details"
        [open]="isSectionOpen('counterparty')"
        (toggle)="toggleSection('counterparty')">
        <div class="transaction-meta-list">
          <div class="transaction-meta-line">
            <span>Counterparty</span>
            <strong>{{ tx.counterpartName || '-' }}</strong>
          </div>
          <div class="transaction-meta-line">
            <span>Bank Account</span>
            <strong>{{ tx.counterpartReference || '-' }}</strong>
          </div>
          <div class="transaction-meta-line">
            <span>Creditor ID</span>
            <strong>{{ tx.creditorId || '-' }}</strong>
          </div>
        </div>
      </app-portal-detail-section>

      <app-portal-detail-section
        title="Link invoice/receipt"
        [open]="isSectionOpen('attachments')"
        (toggle)="toggleSection('attachments')">
        <span portalDetailSectionMeta class="section-header-meta count-meta" *ngIf="unlinkData?.invoiceList?.length">
          <mat-icon>attach_file</mat-icon>
          <span>{{ unlinkData?.invoiceList?.length }}</span>
        </span>

        <div class="linked-invoice-list" *ngIf="unlinkData?.invoiceList?.length; else noLinkedInvoices">
          <div class="linked-invoice-row" *ngFor="let invoice of unlinkData?.invoiceList">
            <div class="linked-invoice-main">
              <mat-icon>description</mat-icon>
              <span>{{ invoice?.invoiceNumber || '-' }}</span>
            </div>
            <button class="linked-invoice-menu" type="button" [matMenuTriggerFor]="invoiceMenu">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu class="m-mat-menu" #invoiceMenu="matMenu" xPosition="before">
              <button mat-menu-item type="button" (click)="attachmentPopup(true, true, invoice)">
                <img src="../../../../assets/images/eye_icon.svg" alt="" width="20px" height="20px" />
                <span class="menu-text">View</span>
              </button>
              <button mat-menu-item type="button" (click)="unlinkDialog(invoice, unlinkData?.transactionId)">
                <img src="../../../../assets/images/unlink_icon_grey.svg" alt="" width="20px" height="20px" />
                <span class="menu-text">Unlink</span>
              </button>
            </mat-menu>
          </div>
        </div>

        <ng-template #noLinkedInvoices>
          <div class="empty-linked-invoices">No invoice or receipt linked yet.</div>
        </ng-template>

        <button class="detail-attach-file" type="button" (click)="attachmentPopup(false, false)">
          + Attach invoice/receipt
        </button>
      </app-portal-detail-section>
    </div>
  </app-portal-detail-drawer>
</ng-container>
